// extracted by mini-css-extract-plugin
export var capsule = "capsule-module--capsule--1cc8a";
export var selected = "capsule-module--selected--f8460";
export var special = "capsule-module--special--e590a";